import { formatInJst } from "@/utils/time";
import { ClockIcon } from "@roman/shared/components/Icons";
import { useCountDown } from "@roman/shared/hooks/useCountDown";
import { cn } from "@roman/shared/utils";

export const SeasonRangeTime = ({
  startDate,
  endDate,
}: {
  startDate: Date | null;
  endDate: Date | null;
}) => {
  if (!startDate || !endDate) {
    return null;
  }

  const { deadlineTime, isOver } = useCountDown(endDate);
  const showCountDown = !isOver && deadlineTime.split(":").length === 3; // Check if the format is "HH:MM:SS"

  return (
    <span className={cn("text-sm not-italic font-normal leading-tight")}>
      {showCountDown ? (
        (() => {
          const [hours, minutes, seconds] = deadlineTime.split(":");

          return (
            <span className="flex gap-[2px] items-end justify-start ">
              <ClockIcon className="w-[18px] h-[18px]" color="#808080" />
              <span>{`${hours}h:${minutes}m:${seconds}s`}</span>
            </span>
          );
        })()
      ) : (
        <>
          {formatInJst(new Date(startDate), "M/d HH:mm")}&nbsp;-&nbsp;
          {formatInJst(new Date(endDate), "M/d HH:mm")}
        </>
      )}
    </span>
  );
};
